import Service from './Service';
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export default class HsmSubnetService extends Service {
    constructor() {
        super();
        this.baseURL = 'hsmSubnet';
    }

    findByProductId(productId) {
        return fetch(SERVER_URL + this.baseURL + '/findByProductId/' + productId, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }
}